<script>

  import { mapGetters, mapState } from 'vuex'
  import { HeadMeta } from '@/utils/head-meta'
  import { gtmSendEvent } from '@/utils/gtm-send-event'

  export default {
    async asyncData ({ app, store }) {
      store.commit('levels/SET_SELECTED_LEVELS', [])
      await store.dispatch('levels/get')
      const { items } = await app.$contentful.getEntries({
        content_type: 'quickScan',
        order: 'fields.title'
      })
      return {
        quickscans: items
      }
    },
    data () {
      return {
        list: [
          {
            icon: 'list',
            color: 'green',
            content: 'Beantwoord een selectie examenvragen voor een vak naar keuze.'
          },
          {
            icon: 'linechart',
            color: 'orange',
            content: 'Krijg direct inzicht in wat je beheerst en wat je nog moet leren en oefenen.'
          },
          {
            icon: 'chat',
            color: 'blue',
            content: 'Inclusief verwijzingen naar de juiste oefen- en leerstof in de Examenbundel en Samengevat boeken.'
          }
        ]
      }
    },
    head () {
      return HeadMeta({
        metaTitle: 'Quickscan',
        metaDescription: 'Test jezelf met onze Quickscans!'
      })
    },
    computed: {
      ...mapState({
        selectedLevels: state => state.levels.selectedLevels
      }),
      ...mapGetters({
        filteredLevels: 'levels/filteredLevels',
        levelOptions: 'levels/levelOptions'
      })
    },
    methods: {
      async levelChange (level) {
        this.$store.commit('levels/SET_SELECTED_LEVEL', level)
        const { items } = await this.$contentful.getEntries({
          content_type: 'quickScan',
          order: 'fields.title',
          ...this.levelOptions
        })
        this.quickscans = items
        gtmSendEvent('quickscan', 'selected-levels', this.selectedLevels.join(','))
      },
      trackEvent (name) {
        gtmSendEvent('quickscan', 'click-quickscan', name)
      }
    }
  }
</script>

<template>
  <article class="view view-quickscan">
    <header class="view-header pb-4 md:pb-14">
      <div class="container px-4 md:px-8">
        <div class="w-full xl:w-8/12 mx-auto">
          <animated-title>
            <h1 class="animate text-3xl md:text-5xl pb-10 md:text-center">
              Test jezelf met onze Quickscans!
            </h1>
          </animated-title>
        </div>
        <div class="w-full md:w-8/12 lg:w-6/12 xl:w-5/12 mx-auto">
          <ul>
            <li
              v-for="(item, i) in list"
              :key="i"
              class="flex mb-6"
            >
              <span
                class="flex-shrink-0 flex justify-center items-center text-white w-12 h-12 rounded mr-6"
                :class="`bg-${item.color}-500`"
              >
                <q-icon :name="item.icon" />
              </span>
              {{ item.content }}
            </li>
          </ul>
          <p><i>Let op! Quickscans zijn er om snel te kijken hoe je ervoor staat voordat je echt begint met leren en oefenen. Haal je een voldoende dan betekent dit niet meteen dat je klaar bent voor je eindexamen.</i></p>
        </div>
      </div>
    </header>
    <div class="container px-4 md:px-8">
      <div class="w-full md:w-8/12 lg:w-6/12 mx-auto">
        <h2 class="text-3xl md:text-center pb-6">
          Welke Quickscan wil je doen?
        </h2>
        <div class="bg-gray-100 rounded text-center py-6 mb-6 md:mb-10">
          <div class="inline-block">
            <e-checkbox
              v-for="option in filteredLevels"
              :id="option.id"
              :key="option.id"
              :value="selectedLevels.includes(option.title)"
              class="mr-4"
              @input="levelChange(option.title)"
            >
              {{ option.title }}
            </e-checkbox>
          </div>
        </div>
        <div class="results">
          <transition-group
            name="list-transition"
            tag="div"
            class="relative"
          >
            <a
              v-for="entry in quickscans"
              :key="entry.sys.id"
              :href="entry.fields.link"
              target="_blank"
              class="block w-full bg-white rounded shadow hover:shadow-focus px-4 py-3 mb-4"
              @click="trackEvent(entry.fields.title)"
            >
              {{ entry.fields.title }}
            </a>
          </transition-group>
        </div>
      </div>
    </div>
  </article>
</template>
